import React, { useRef, useContext } from 'react';
import ToCLink from './ToCLink';
import { useGSAP } from '@gsap/react';
import Context from '../OriginStoryProvider';
import {revealOnScroll} from '../animations/animations';

const ToC = () => {
	const { data: {content} } = useContext(Context);
	
	const tocContainer = useRef();

	useGSAP(() => {		
		if (!content.tableOfContents) return;

		revealOnScroll('#toc__title', 'top bottom-=20%');
		revealOnScroll('.toc__chapters', 'top bottom-=20%');
	}, {scope: tocContainer.current, dependencies: [content.tableOfContents]});

	const renderChapters = (category) => {
		if (!content.tableOfContents[category].chapters.length) return null;

		return (
			<>
				<p className='toc__label label-text'>{content.tableOfContents[category].label}</p>
				<ul className={`toc__list ${category}`}>
					{
						content.tableOfContents[category].chapters.map((chapter) => {
							return (
								<ToCLink key={chapter.slug} number={chapter.number} chapter={chapter.title} href={chapter.slug} category={category} />
							)
						})
					}
				</ul>
			</>
		)
	}

	if (!content.tableOfContents) return null;

	return (
		<section className='toc main-grid' aria-labelledby='toc__title'>
			<div className='main-grid__margin'></div>
			<div className='main-grid__body' ref={tocContainer}>
				<h2 className='toc__title h1' id='toc__title'>{content.tableOfContents.title}</h2>
				<div className='toc__chapters'>
					{renderChapters('released')}
					{renderChapters('unreleased')}
				</div>
			</div>
			<div className='main-grid__margin'></div>
		</section>
	)
}

export default ToC;